import { gettext } from '@eventbrite/i18n';
import loadable from '@loadable/component';
import React from 'react';
import { viewPasswordAction } from '../../actions/password';
import { signupUserAction } from '../../actions/signup';
import SignupForm from '../../components/forms/SignupForm';
import {
    IConfigContextProps,
    useConfigContext,
} from '../../contexts/ConfigContext';
import {
    IFrontendContext,
    useFrontendContext,
} from '../../contexts/FrontendContext';
import { IUserContext, useUserContext } from '../../contexts/UserContext';
import {
    shouldAllowHeader,
    shouldAllowNotifications,
} from '../../utils/conditionals';

const Signup = ({ routing }: { routing?: any }) => {
    const userContext: IUserContext = useUserContext();
    const configContext: IConfigContextProps = useConfigContext();
    const frontendContext: IFrontendContext = useFrontendContext();

    let contentHeader = null;
    if (shouldAllowHeader(configContext)) {
        const Header = loadable(() => import('../../components/common/Header'));
        contentHeader = (
            <Header
                titleText={
                    configContext.header?.titleText ??
                    gettext('Create an account')
                }
                subtitleText={configContext.header?.subtitleText}
                headerLinkProps={configContext.header?.headerLinkProps}
            />
        );
    }

    let contentNotification = null;
    if (shouldAllowNotifications(configContext)) {
        const Notifications = loadable(
            () => import('../../components/common/Notifications'),
        );

        contentNotification = <Notifications section="signup" />;
    }

    return (
        <>
            {contentHeader}

            {contentNotification}

            <SignupForm
                email={userContext.state.lookup.lookedAccount}
                submitButtonText={gettext('Create account')}
                handleSubmit={signupUserAction}
                onEmailEdit={() => {
                    frontendContext?.methods.setSignupSecondStep(false);
                }}
                onShowPasswordClick={viewPasswordAction}
                routing={routing}
            />
        </>
    );
};

export default Signup;
